import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#666",
      "fill-rule": "evenodd",
      d: "M8 .918c0-.506-.44-.917-.981-.917L.98 0C.44 0 0 .411 0 .917v.367c0 .208.076.41.215.573L2.366 4.37c.032.038.05.084.05.132v2.84c0 .348.21.666.542.821l1.644.769a.72.72 0 0 0 .66-.028c.201-.116.323-.32.323-.54V4.503c0-.048.018-.094.05-.132l2.15-2.514A.882.882 0 0 0 8 1.285V.918ZM1.07 1h5.86v.254L4.8 3.747l-.085.111c-.13.193-.2.416-.2.645v3.271l-1.031-.482V4.503l-.007-.136a1.171 1.171 0 0 0-.275-.62L1.069 1.255V1Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "filter"}) } }